<template>
  <div class="app-code-check">
    <h2 class="authentication__title text-center" v-text="'Введите код'" />
    <form class="app-code-check__form">
      <app-security-code v-model="code"></app-security-code>
    </form>
    <!-- <div class="app-code-check__group">
      <div class="app-code-check__group-item">
        <span class="app-code-check__countdown dark-gray">Через 59 сек</span>
        <app-button-control class="dark-gray" type="link">Отправить ещё</app-button-control>
      </div>
      <div class="app-code-check__group-item app-code-check__group-item--right">
        <app-button-control type="link">Изменить номер</app-button-control>
        <app-button-control type="link">Не приходит СМС?</app-button-control>
      </div>
    </div> -->
  </div>
</template>

<script>
import AppSecurityCode from '@/components/ui/AppSecurityCode.vue';

export default {
  name: 'AppCodeCheck',
  components: {
    AppSecurityCode,
    // AppButtonControl: () => import('@/components/ui/AppButtonControl'),
  },
  data: () => ({
    code: '',
  }),
  watch: {
    code(value) {
      if (value.length) {
        this.onComplete();
      }
    },
  },
  methods: {
    onChange() {
      // -
    },
    onComplete() {
      // -
    },
  },
};
</script>

<style lang="scss">
.app-code-check {
  &__form {
    display: flex;
    margin: 30px 0;
  }

  &__group {
    display: flex;
    justify-content: space-between;
  }

  &__group-item {
    display: flex;
    flex-direction: column;

    &--right {
      align-items: flex-end;
    }
  }

  &__countdown {
    font-size: 12px;
    line-height: 24px;
  }
}
</style>
